"use strict";

var _toConsumableArray = require("/builds/2Lnp9sT1/0/kilornd/react/archive/pulsio/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ring;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styleModule = _interopRequireDefault(require("./style.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function Ring(_ref) {
  var color = _ref.color,
      size = _ref.size,
      className = _ref.className,
      style = _ref.style;

  var circles = _toConsumableArray(Array(4)).map(function (_, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      style: {
        borderColor: "".concat(color, " transparent transparent transparent"),
        width: size * 0.8,
        height: size * 0.8,
        margin: size * 0.1,
        borderWidth: size * 0.1
      }
    });
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styleModule.default['lds-ring'], className),
    style: _objectSpread({
      width: size,
      height: size
    }, style)
  }, circles);
}

Ring.propTypes = {
  /** hex color */
  color: _propTypes.default.string,

  /** size in pixel */
  size: _propTypes.default.number,

  /** class name  */
  className: _propTypes.default.string,

  /** style object */
  style: _propTypes.default.object
};
Ring.defaultProps = {
  color: '#7f58af',
  size: 80,
  className: '',
  style: {}
};